module.exports = __webpack_public_path__ + "static/media/bitcoin-cryptocurrency-vault-safelock_SOIN20003_905168316_is_1560x880.621a885c.jpg";